import { AxiosError } from "axios";
import { getNotificationStyle } from "../common/notification";
import {
  IAdhocDetails,
  IPagination,
  ITripplanDriverWeb,
} from "../model/CommonModel";
import {
  IAssignDriver,
  IRefresh,
  ITripActual,
  ITripExceptionOtp,
  ITripPlanDetail,
  ITripPlanFilterData,
  ITripPlanRequest,
  ITripRequest,
  ITripSchedule,
  ITripSearchRequest,
} from "./../model/TripPlanModel";
import AjexPortalService from "./api";
import config from "./config";
import { IFetchFiles } from "../model/BookingModel";

const commonURL: string | undefined = process.env.REACT_APP_TMS_COMMON_SERVICE;
const readURL = process.env.REACT_APP_TMS_READ_SERVICE;
const occURL = process.env.REACT_APP_TMS_OCC_SERVICE;
const prodToken = process.env.REACT_APP_PROD_TOKEN;
const token = process.env.REACT_APP_TOKEN;

const tripRoute = config.get("tripRoute");
const tripPlan = config.get("tripPlan");
const tripType = config.get("tripType");
const tripLoadType = config.get("tripLoadType");
const getWayBill = config.get("getWayBill");
const getFiles = config.get("getFiles");
const complete = config.get("complete");
const closed = config.get("closed");
const tripPlanNumber = config.get("tripPlanNumber");
const tripHistory = config.get("tripHistory");
const tripId = config.get("tripId");
const tripplanBan = config.get("tripplanBan");
const tripplanDetail = config.get("tripplanDetail");
const updateTripplanDetails = config.get("updateTripplanDetails");
const tripException = config.get("tripException");
const tripSchedule = config.get("tripSchedule");
const tripScheduleActual = config.get("tripScheduleActual");
const refresh = config.get("refresh");
const assignDriver = config.get("assignDriver");
const updateAdhocDetails = config.get("updateAdhocDetails");
const tripplanDriverOperation = config.get("tripplanDriverOperation");
const saveTripplanDriverWeb = config.get("saveTripplanDriverWeb");
const tripDetails = config.get("tripDetails");
const tripSheetPrint = config.get("tripSheetPrint");
const tripSheet = config.get("tripSheet");
const manifestSheet = config.get("manifestSheet");
const print = config.get("print");
const paginated = config.get("paginated");
const filter = config.get("filter");
const page = config.get("page");
const size = config.get("size");
const getWaybillByTripCode = config.get("getWaybillByTripCode");
const fleet = config.get("fleet");
const vehicle = config.get("vehicle");
const vehicleManifestPrint = config.get("vehicleManifestPrint");
const fileAttachment = config.get('fileAttachment');
const uploadMultipleFile = config.get('uploadMultipleFile');
const category = config.get("category");
const fleetURL = process.env.REACT_APP_TMS_FLEET_MANAGEMENT_SERVICE;

export const GetTripPlanService = async ({
  page: pageNum,
  size: sizeNum,
}: IPagination) => {
  try {
    return await AjexPortalService.get(
      `${commonURL}${tripPlan}/${paginated}?${page}=${pageNum}&${size}=${sizeNum}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetTripByNumberService = async (request: ITripSearchRequest) => {
  //https://apps-sit.aj-ex.com/tms-common-service/api/v1/tripplan/filter/TP0000000258
  try {
    const { tripRoute, tripplanNumber } = request || {};
    let queryURL: string = "";
    if (tripRoute) queryURL = `tripRoute=${tripRoute}`;
    if (tripplanNumber) queryURL = `tripplanNumber=${tripplanNumber}`;
    if (tripplanNumber && tripRoute)
      queryURL = `tripplanNumber=${tripplanNumber}&tripRoute=${tripRoute}`;
    return await AjexPortalService.get(
      `${commonURL}${tripPlan}/${filter}?${queryURL}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetTripPlanByIdService = async (id: number) => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripPlan}/${id}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const GetTripCodeService = async () => {
  try {
    return await AjexPortalService.get(`${tripRoute}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};
export const GetTripTypeService = async () => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripType}/`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const GetTripPlanById = async (id: number) => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripPlan}/${id}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const SaveTripPlanService = async (data: ITripPlanRequest) => {
  try {
    return await AjexPortalService.post(`${commonURL}${tripPlan}`, data);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const UpdateTripPlanService = async (
  data: ITripPlanRequest,
  id: number
) => {
  try {
    return await AjexPortalService.put(`${commonURL}${tripPlan}/${id}`, data);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const DeleteTripPlanByIdService = async (id: number) => {
  try {
    return await AjexPortalService.delete(`${commonURL}${tripPlan}/${id}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetTripLoadTypeService = async () => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripLoadType}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};
export const GetTripPlanWaybillService = async (id: number) => {
  try {
    return await AjexPortalService.get(
      `${commonURL}${tripPlan}/${getWayBill}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const CompleteTripPlanService = async (request: ITripRequest) => {
  try {
    return await AjexPortalService.put(
      `${commonURL}${tripPlan}/${complete}?${tripPlanNumber}=${request?.tripPlanNumber}`,
      request
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const ClosedTripPlanService = async (request: ITripRequest) => {
  try {
    return await AjexPortalService.put(
      `${commonURL}${tripPlan}/${closed}?${tripPlanNumber}=${request?.tripPlanNumber}`,
      request
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetTripPlanFilesService = async (id: number) => {
  try {
    return await AjexPortalService.get(
      `${commonURL}${tripPlan}/${getFiles}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};
// https://apps-sit.aj-ex.com/tms-common-service/api/v1/trip-history/trip-id/139
export const GetTripHistoryService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripHistory}/${tripId}/${id}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};
export const GetTripPlanBanService = async (id: number) => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripplanBan}/${id}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetTripPlanDetailByIdService = async (id: number) => {
  try {
    return await AjexPortalService.get(
      `${commonURL}${tripPlan}/${tripplanDetail}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const UpdateTripDetailService = async (
  data: ITripPlanDetail,
  id: number
) => {
  try {
    return await AjexPortalService.put(
      `${commonURL}${tripPlan}/${updateTripplanDetails}/${id}`,
      data
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GenerateTripOTPService = async (data: ITripExceptionOtp) => {
  try {
    return await AjexPortalService.post(`${commonURL}${tripException}`, data);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

//https://apps-sit.aj-ex.com/tms-common-service/api/v1/tripschedule
export const GetTripScheduleService = async ({ page, size }: { page: number; size: number }) => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripSchedule}/paginated?page=${page < 1 ? 0 : page - 1}&size=${size ?? 10}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};
export const GetTripActualScheduleService = async ({ page, size }: { page: number; size: number }) => {
  try {
    return await AjexPortalService.get(`${commonURL}${tripScheduleActual}/paginated?page=${page < 1 ? 0 : page - 1}&size=${size ?? 10}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const SaveTripScheduleService = async (
  request: Omit<ITripSchedule, "clientId">
) => {
  try {
    return await AjexPortalService.post(`${commonURL}${tripSchedule}`, request);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const UpdateTripScheduleService = async (
  request: Pick<
    ITripSchedule,
    | "id"
    | "consigneeId"
    | "subClientId"
    | "statusId"
    | "scheduleTypeId"
    | "tripScheduleDetailsDtoList"
  >
) => {
  try {
    return await AjexPortalService.put(`${commonURL}${tripSchedule}`, request);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const DeleteTripActualService = async (request: ITripActual) => {
  try {
    return await AjexPortalService.delete(`${commonURL}${tripSchedule}`, {
      data: request,
    });
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const UpdateTripActualService = async (request: ITripActual) => {
  try {
    return await AjexPortalService.put(
      `${commonURL}${tripScheduleActual}`,
      request
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const RefreshActualTripService = async (request: IRefresh) => {
  try {
    return await AjexPortalService.post(
      `${commonURL}${tripScheduleActual}/${refresh}`,
      request
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const AssignScheduleDriverService = async (request: IAssignDriver) => {
  try {
    return await AjexPortalService.post(
      `${commonURL}${tripSchedule}/${assignDriver}`,
      request
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetTripOtpListService = async (id: number) => {
  try {
    return await AjexPortalService.get(
      `${commonURL}${tripException}/${tripId}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const UpdateAdhocDetailService = async (
  data: IAdhocDetails,
  id: number
) => {
  try {
    return await AjexPortalService.put(
      `${commonURL}${tripPlan}/${updateAdhocDetails}/${id}`,
      data
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const SaveTripPlanDriverWebService = async (
  data: ITripplanDriverWeb
) => {
  try {
    return await AjexPortalService.post(
      `${commonURL}${tripplanDriverOperation}/${saveTripplanDriverWeb}`,
      data
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetTripPlanDriverListByIdService = async (id: number) => {
  try {
    return await AjexPortalService.get(
      `${commonURL}${tripplanDriverOperation}/${tripDetails}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};
export const PrintTripPlanService = async (id: number | undefined) => {
  try {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/trip-sheet-print/{id}
    return await AjexPortalService.get(
      `${commonURL}${print}/${tripSheetPrint}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const PrintTripSheetService = async (id: number | undefined) => {
  try {
    //http://localhost:6211/api/v1/print/trip-sheet/{id}
    return await AjexPortalService.get(
      `${readURL}${print}/${tripSheet}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const PrintManifestSheetService = async (id: number | undefined) => {
  try {
    //http://localhost:6211/api/v1/print/manifest-sheet/{id}
    return await AjexPortalService.get(
      `${readURL}${print}/${manifestSheet}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const GetWaybillByTripPlanService = async (tripNumber?: string) => {
  //https://apps-sit.aj-ex.com/tms-common-service/api/v1/tripplan/get-waybill-by-trip-code/TP0000000268
  try {
    return await AjexPortalService.get(
      `${commonURL}${tripPlan}/${getWaybillByTripCode}/${tripNumber}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetDriverDetailByIdService = async (id?: number) => {
  try {
    return await AjexPortalService.get(
      `${fleetURL}/${fleet}/assignment/driver/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const GetVehicleListService = async (type: string) => {
  try {
    return await AjexPortalService.get(
      `${fleetURL}${vehicle}/vehicle-type/${type}`
      // https://apps-sit.aj-ex.com/tms-fleet-management-service/api/v1/vehicle/vehicle-type/TRAILOR
      // http://localhost:6214/api/v1/vehicle/vehicle-type/TRAILOR
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const PrintVehicleManifestService = async (id: number | undefined) => {
  try {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/print/trip-sheet-print/{id}
    return await AjexPortalService.get(
      `${commonURL}${print}/${vehicleManifestPrint}/${id}`
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const GetTripExceptionService = async (id: string) => {
  try {
    //https://apps-sit.aj-ex.com/tms-common-service/api/v1/trip-exception/get-trip-exception/628
    return await AjexPortalService.get(`${commonURL}trip-exception/get-trip-exception/${id}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

//https://apps-sit.aj-ex.com/tms-common-service/api/v1/file-attachment/upload-multiple-file
export const UploadTripExceptionFileService = async (request) => {
  try {
    const configuration = {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    };
    return await AjexPortalService.post(`${commonURL}${fileAttachment}/${uploadMultipleFile}`, request, configuration)
  } catch (error: unknown) {
    const err = error as AxiosError
    getNotificationStyle(err?.response);
    return (err?.response)
  }
}



export const DownloadTripExceptionService = async (id: number) => {
  try {
    return await AjexPortalService.get(`${commonURL}file-attachment/download-single-file/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError
    return (err?.response);
  }
}

export const GetOnHoldTerminalExceptionService = async (payload: any) => {
  try {
    // https://apps-sit.aj-ex.com/tms-common-service/api/v1/exception-approve/get-exceptions?exceptionCategory=Hold-Terminal&startDate=2021-05-25&endDate=2025-05-27
    const params = new URLSearchParams();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, String(value));
      }
    });

    return await AjexPortalService.get(`${commonURL}exception-approve/get-exceptions?${params.toString()}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

export const FilterPaginatedTripPlanService = async (
  page: number,
  size: number,
  filterData: ITripPlanFilterData
) => {
  try {
    return await AjexPortalService.post(
      `${commonURL}tripplan/paginated/filter?page=${page}&size=${size}`, filterData);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export interface ITripPlanVehicleDetailsFilter {
  businessId?: number;
  startDate?: string;
  endDate?: string;
  cityId?: number;
}

export const GetTripPlanVehicleDetailsService = async (
  filter?: ITripPlanVehicleDetailsFilter
) => {
  try {
    // businessId/cityId are user-clearable filters (see TripMapComponent's
    // BUID/City selects) — when neither is selected, the param is left
    // out of the query string entirely rather than sent as some
    // placeholder value.
    const params: Record<string, string | number> = {};
    if (filter?.businessId != null) params.businessId = filter.businessId;
    if (filter?.cityId != null) params.cityId = filter.cityId;
    if (filter?.startDate) params.startDate = filter.startDate;
    if (filter?.endDate) params.endDate = filter.endDate;

    return await AjexPortalService.get(`${occURL}tripplan-vehicles/details`, {
      params,
    });
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const TrackVehicleService = async (filterData: { filterType: string; id: string; date: string }) => {
  try {
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    return await AjexPortalService.post(`https://apps.aj-ex.com/tms-occ-service/api/v1/occ/filter`, filterData, config);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetVehicleLatLngHistoryService = async (request: { fromdate: string; license: string }) => {
  try {
    return await AjexPortalService.post(`${occURL}occ/history/getvehiclelatlng`, request);
  } catch (error: unknown) {
    const err = error as AxiosError;
    // getNotificationStyle(err?.response);
    return err?.response;
  }
};


export const GetTripPlanGroupedCountService = async (
  cityIds: number[],
  fromDate: string,
  toDate: string
) => {
  try {
    const params = new URLSearchParams({
      cityIds: cityIds.join(","),
      fromDate,
      toDate,
    }).toString();
    return await AjexPortalService.get(`${commonURL}tripplan/count/grouped/all/v2?${params}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    // getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetTripPlanWaybillsByPlateNoService = async (plateNo: string) => {
  try {
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    return await AjexPortalService.get(`https://apps.aj-ex.com/tms-occ-service/api/v1/occ/trip-plan-waybills?plateNo=${encodeURIComponent(plateNo)}`, config);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetVehicleTrackingHistoryService = async (request: { id: string; fromDate: string; toDate: string }) => {
  try {
    if (!request || !request.id || !request.fromDate || !request.toDate) {
      return Promise.reject(new Error("Invalid request parameters"));
    }
    const reqWithRole = { ...request, role: "ROLE_VT_HOD" };
    return await AjexPortalService.post(`https://apps.aj-ex.com/tms-occ-service/api/v1/occ/vehicle-tracking-history`, reqWithRole);
  } catch (error: unknown) {
    const err = error as AxiosError;
    // getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const MarkWaybillsOnTimeService = async (request: { waybillNos: string[]; remarks: string }) => {
  try {
    return await AjexPortalService.put(`${occURL}occ-slr/waybills`, request);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetRouteOptimizationTripService = async (tripId: number) => {
  try {
    const url = `https://apps.aj-ex.com/tms-geofencing-service/api/v1/route-optimization/trip/${tripId}`;
    return await AjexPortalService.get(url);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

